import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { formatBookingNotificationDate, formatNotificationDate } from './notificationDate';
import { toNotificationViewModel } from './notificationViewModel';

const localTime = (value) => {
  const parsed = moment(value, ['YYYY-MM-DD HH:mm:ss', 'HH:mm:ss', 'HH:mm'], true);
  return parsed.isValid() ? parsed.format('h:mm A') : '';
};

const monthLabel = (value) => {
  const parsed = moment(value, 'YYYY-MM-DD', true);
  return parsed.isValid() ? parsed.format('MMMM YYYY') : '';
};

export default function NotificationSchedule({ row }) {
  const view = toNotificationViewModel(row);
  const waitlist = row.waitlist || {};
  const appointment = row.appointment || {};
  // A month waitlist stores the 1st as its anchor; only an offer knows the day.
  const offered = waitlist.offered_local_start_datetime;
  const waitlistDate = offered ? formatNotificationDate(offered)
    : waitlist.preferred_scope === 'month' ? monthLabel(waitlist.preferred_date) : formatNotificationDate(waitlist.preferred_date);
  const date = view.isWaitlistNotification ? waitlistDate : formatBookingNotificationDate(row);
  const start = localTime(appointment.local_start_datetime);
  const end = localTime(appointment.local_end_datetime);
  const time = view.isWaitlistNotification
    ? localTime(offered) || localTime(waitlist.preferred_time) || waitlist.preferred_time || ''
    : [start, end].filter(Boolean).join(' – ');
  return <>
    {view.isWaitlistNotification && waitlist.service && <p className="fw-semibold mb-0">
      {view.serviceName}{view.staffDisplayName ? ` with ${view.staffDisplayName}` : ''}
    </p>}
    {date && <p className="fw-semibold mb-0">{date}</p>}
    {time && <p className="mb-0">{time}</p>}
  </>;
}

NotificationSchedule.propTypes = { row: PropTypes.object.isRequired };
